module.exports = __webpack_public_path__ + "assets/img/icon1.4d5b7cf5.png";